import React, { useRef, useState } from 'react';
import { color } from 'theme.material';
import { useTheme } from '@mui/material';
import {
  InputButton,
  PostAvatar,
  Wrapper,
} from './PostDiscussionMagnet.styles';
import { PostDiscussionMagnetPropTypes } from './PostDiscussionMagnet.types';
import { PostDiscussionModal } from './PostDiscussionModal/PostDiscussionModal';

const newUIAvatarSize = 10.5;

export function PostDiscussionMagnet({
  className,
  user,
  loading,
  modalProps,
  magnetProps,
  noPadding,
  bgColor,
  newUI = false,
}: PostDiscussionMagnetPropTypes): JSX.Element {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  function handleModalOpen(event) {
    event.preventDefault();
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }
  return (
    <Wrapper
      className={className}
      noPadding={noPadding}
      bgColor={bgColor}
      newUI={newUI}
    >
      <PostAvatar
        size={{
          desktop: newUI ? newUIAvatarSize : 14,
          mobile: newUI ? newUIAvatarSize : 12,
        }}
        fontSize={{ desktop: newUI ? 5 : 7, mobile: newUI ? 5 : 6 }}
        name={user?.firstName}
        image={user?.image?.url}
        backgroundColor={color.teal[500]}
      />

      <InputButton
        onClick={handleModalOpen}
        onFocus={handleModalOpen}
        fullWidth
        newUI={newUI}
        variant={magnetProps?.buttonVariant as any}
        theme={theme}
      >
        {magnetProps?.placeholder}
      </InputButton>
      <PostDiscussionModal
        ref={modalRef}
        {...modalProps}
        user={user}
        isOpen={isOpen}
        loading={loading}
        handleClose={handleClose}
      />
    </Wrapper>
  );
}
